import React, {Component} from 'react';

//controllerAPI
import MemberControllerAPI from '../../../controllers/API/MemberControllerAPI.js';

import styles from '../../../static/css/componentStyleModules/inputComponentStyleModules/memberSelectComponent.module.scss';
import FaceIconBaseComponent from '../../faceIconComponents/FaceIconBaseComponent.js';

export default class MemberSelectComponent extends Component {

    constructor(props){
        super(props);
        this.state = {
            memberList:[],
            nullMember:{
              member_id:null,
              name:'ななしさん',
              head:'basic',
              face:'basic',
              color:'#888888'
            },
            selectedMember:{},

            inIconAnimation:false,
        }
    }

    componentWillMount = () => {

        if(this.props.selectedMemberId !== null){            
            MemberControllerAPI.show(this.props.selectedMemberId)
            .then((result) => {
                if(result.data === undefined){
                    console.log('登録していたメンバーが消えていた');
                    this.setState({selectedMember:this.state.nullMember})
                }else{
                    this.setState({selectedMember:result.data});
                }
                
            })
            .catch((error) => {
                console.log(error.message);
            })
        }else {
            const nullMember = this.state.nullMember;
            this.setState({selectedMember:nullMember});
        }

        MemberControllerAPI.index()
        .then((result) => {
            this.setState({memberList:result.data});
        })
        .catch((error) => {
            console.log(error.message);
        })
    }

    componentDidMount = () => {
        process.nextTick(() => {
            this.refs.memberSelectArea.classList.remove(styles['hidden']);
        })
    }

    pickupMember = (member) => {

        if(this.state.inIconAnimation){
            //アニメーション中なら、一旦止めてすぐ再開させる
            this.setState({inIconAnimation:false});
            process.nextTick(() => {
                this.setState({inIconAnimation:true});
            })
            
        }else{
            this.setState({inIconAnimation:true});
        }

        setTimeout(() => {
            this.setState({selectedMember:member});
        },200)

    }

    selectMember = (member) => {
        if(typeof member.id === 'undefined'){
            //nullメンバーのidがundefinedになっているので、nullに直す
            member.id = null;
        }
        //idと顔と色をおろす
        this.props.onEnterClick(
            member.id,
            member.name,
            member.head,
            member.eyes,
            member.eyeblows,
            member.mouth,
            member.color
        );        
    }

    render() {

        const mainIconClass = () => {
            if(this.state.inIconAnimation){
                setTimeout(() => {
                    this.setState({inIconAnimation:false});
                },500)
                return styles['memberIcon'] + ' ' + styles['inAnimation'];
            }else{
                return styles['memberIcon'];
            }
        }

        const memberGrid = (member) => {
            return (
                <div className={styles['memberGrid'] + ' touchActivePush'} key={member.id}
                onClick={() => this.pickupMember(member)}>
                  <div className={styles['memberIcon']}>
                    <FaceIconBaseComponent 
                    head={member.head}
                    eyes={member.eyes}
                    eyeblows={member.eyeblows}
                    mouth={member.mouth}
                    fillColor={member.color}
                    />
                  </div>
                  <p>{member.name}</p>
                </div>
            )
        }

        return (
            <div className={styles['memberSelectArea'] + ' ' + styles['hidden']} ref="memberSelectArea">
              {this.state.selectedMember.name !== undefined && (
                  <div className={styles['currentMemberDisplayBase']}>
                    <div className={styles['currentMemberDisplayArea']}
                    onClick={() => this.pickupMember(this.state.selectedMember)}>
                      <div className={mainIconClass()}>
                        <FaceIconBaseComponent
                        head={this.state.selectedMember.head}
                        eyes={this.state.selectedMember.eyes}
                        eyeblows={this.state.selectedMember.eyeblows}
                        mouth={this.state.selectedMember.mouth}
                        fillColor={this.state.selectedMember.color}
                        />
                      </div>
                      <p>{this.state.selectedMember.name}</p>
                    </div>
                  </div>
              )}
              <div className={styles['memberSelectGridBase']}>
                <div className={styles['memberSelectButtonArea']}>
                  <div className="touchActiveDark"
                  onClick={this.props.onCancelClick}>キャンセル</div>
                  <div className="touchActiveDark"
                  onClick={() => this.selectMember(this.state.selectedMember)}>OK</div>
                </div>
                <div className={styles['memberSelectGridArea']}>
                  {memberGrid(this.state.nullMember)}
                  {this.state.memberList.map(memberGrid)}
                </div>
              </div>
            </div>
        )
    }

};